module.exports = __webpack_public_path__ + "static/img/banner-newhome.24e3393.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/government/banner-newhome.png
// module id = HL+D
// module chunks = 44